<app-page-title icon="fa-microphone" title="Editar Áudio">
  <a [routerLink]="['/call4u-audios']" class="btn btn-secondary">
    <i class="fa fa-arrow-left"></i> Voltar
  </a>
</app-page-title>

<app-skeleton *ngIf="loading" variant="text" [count]="6"
  label="Carregando o áudio" data-testid="audio-loading"></app-skeleton>

<form *ngIf="!loading && audio" (submit)="save()">

  <!-- Informações do Áudio -->
  <div class="card elevated mb-3">
    <div class="card-body">
      <h3><span>1</span><p>Informações do Áudio</p></h3>

      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="form-group">
            <label for="title">Título</label>
            <input
              type="text"
              id="title"
              class="form-control"
              [(ngModel)]="title"
              name="title"
              placeholder="Ex: Áudio de boas-vindas"
              maxlength="255"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="text">Texto do Áudio</label>
            <textarea
              id="text"
              class="form-control"
              [(ngModel)]="text"
              name="text"
              rows="4"
              placeholder="Descrição ou texto de referência do áudio"
              maxlength="5000"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Áudio -->
  <div class="card elevated mb-3">
    <div class="card-body">
      <h3><span>2</span><p>Áudio</p></h3>

      <div class="audio-info">
        <div class="d-flex align-items-center gap-3">
          <button
            type="button"
            class="btn-play-large"
            (click)="togglePlayer()"
            [disabled]="!audio.file_url"
          >
            <i class="fa" [ngClass]="isPlayerPlaying ? 'fa-stop' : 'fa-play'"></i>
          </button>
          <div class="flex-grow-1">
            <div class="audio-detail">
              <span class="audio-detail-label">Tipo:</span>
              <span>{{ getTypeLabel(audio.type) }}</span>
            </div>
            <div class="audio-detail">
              <span class="audio-detail-label">Duração:</span>
              <span>{{ formatDuration(audio.duration_seconds) }}</span>
            </div>
            <div class="audio-detail" *ngIf="audio.file_name">
              <span class="audio-detail-label">Arquivo:</span>
              <span>{{ audio.file_name }}</span>
            </div>
          </div>
        </div>
        <div *ngIf="!audio.file_url" class="mt-2">
          <small class="text-warning">
            <i class="fa fa-exclamation-triangle me-1"></i>Áudio ainda não disponível para reprodução
          </small>
        </div>
      </div>
    </div>
  </div>

  <!-- Ações por Dígito -->
  <div class="card elevated mb-3">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-start mb-3">
        <h3 class="mb-0"><span>3</span><p>Ações por Dígito <small style="font-size: 0.7rem; text-transform: none; color: #9aa2a8;">(opcional)</small></p></h3>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          (click)="addAction()"
          [disabled]="dtmfActions.length >= 14"
        >
          <i class="fa fa-plus me-1"></i> Adicionar
        </button>
      </div>

      <small class="d-block mb-3" style="color: #9aa2a8;">
        Configure ações que serão executadas quando o lead pressionar uma tecla durante a ligação
      </small>

      <!-- Vazio -->
      <div *ngIf="dtmfActions.length === 0" class="empty-actions">
        <i class="fa fa-keyboard-o fa-2x"></i>
        <p>Nenhuma ação configurada</p>
        <small>Clique em "Adicionar" para definir ações por tecla</small>
      </div>

      <!-- Ações -->
      <div *ngFor="let action of dtmfActions; let i = index" class="action-row mb-2">
        <div class="row align-items-end">
          <div class="col-md-2 col-sm-3">
            <div class="form-group mb-0">
              <label>Opção</label>
              <select class="form-control" [(ngModel)]="action.dtmf_key" [name]="'dtmf_key_' + i">
                <option value="" disabled>--</option>
                <option *ngFor="let key of getAvailableKeys(i)" [value]="key.key">{{ key.label }}</option>
              </select>
            </div>
          </div>

          <div class="col-md-3 col-sm-9">
            <div class="form-group mb-0">
              <label>Ação</label>
              <select class="form-control" [(ngModel)]="action.action_type" [name]="'action_type_' + i">
                <option value="" disabled>Selecione a ação</option>
                <option *ngFor="let at of actionTypes" [value]="at.value">{{ at.label }}</option>
              </select>
            </div>
          </div>

          <div class="col-md-5 col-sm-10" *ngIf="needsTextParam(action.action_type)">
            <div class="form-group mb-0">
              <label>{{ getParamLabel(action.action_type) }}</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="action.action_text"
                [name]="'action_text_' + i"
                [placeholder]="getParamPlaceholder(action.action_type)"
              />
            </div>
          </div>

          <div class="col-md-5 col-sm-10" *ngIf="needsListParam(action.action_type)">
            <div class="form-group mb-0">
              <label>Lista</label>
              <select
                class="form-control"
                [(ngModel)]="action.action_list_id"
                [name]="'action_list_' + i"
              >
                <option value="" disabled>Selecione uma lista</option>
                <option *ngFor="let list of lists" [value]="list.id">{{ list.name }}</option>
              </select>
            </div>
          </div>

          <div class="col-md-2 col-sm-2">
            <button type="button" class="btn btn-sm btn-danger" (click)="removeAction(i)" title="Remover">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Botões -->
  <div class="mb-4">
    <button
      type="submit"
      class="btn btn-primary me-2"
      [appLoadingButton]="saving"
      [disabled]="!isFormValid"
    >
      <i class="fa fa-check me-1"></i>
      Salvar Alterações
    </button>
    <a [routerLink]="['/call4u-audios']" class="btn btn-secondary">Cancelar</a>
  </div>
</form>
